var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-select"},[_c('multiselect',{attrs:{"options":_vm.optionSelect,"searchable":_vm.searchable,"placeholder":_vm.placeholder,"label":_vm.label,"disabled":_vm.disabled,"allow-empty":_vm.allowEmpty},on:{"search-change":_vm.onSearchChange},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }